import { useEffect } from 'react'
import { useWatch, Control, FieldValues, FieldValue } from 'react-hook-form'

export function useFormAutoSave<T extends FieldValues>(
    control: Control<T>, 
    onSave: (data: T) => void,
    defaultValue: T
) {
    const formWatch = useWatch({
        control,
        defaultValue: defaultValue as any,
    })

    useEffect(() => {
        onSave(formWatch as T)
    }, [formWatch])

    return formWatch
}
